import { LeftOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getCourseModulesDetailsData,
  getCourseraContentsDetails,
} from "../../slices/courseraSlice";
import Announcements from "../Announcements";
import CourseMaterial from "../CourseMaterial";
import Feedback from "../Feedback";
import Instructors from "../Instructors";
import MyCollapse from "../Interactions/MyCollapse";
import Notes from "../Notes";
import Program from "../Program";
import ReadCourseForum from "../ReadCourseForum";
import GradesTable from "../Table/GradesTable";
import GradientButton from "../Button/GradientButton";

const CourseDetails = ({ contentUrl }) => {
  const [selectedWeek, setSelectedWeek] = useState("Week 1");
  const [selectedMenu, setSelectedMenu] = useState("Course Material");
  const courseData = useSelector((state) => state.coursera.courseData);
  const courseModuleData = useSelector(
    (state) => state.coursera.courseModulesDetailsData
  );
  const courseDataDetails = useSelector(
    (state) => state.coursera.courseDetailsData
  );

  const courseModuleSelectedData = courseModuleData?.filter(
    (id) => selectedWeek === id.id
  )[0];
  const selectedCourseData = courseDataDetails?.filter(
    (id) => selectedWeek === id.id
  )[0];

  const dispatch = useDispatch();
  const { id } = useParams();
  const moduleId = id.split("~")[1];
  const data = courseData?.elements?.filter((data) => data.id === id)[0];

  const dataId = data?.extraMetadata?.definition?.courseIds;
  const navigate = useNavigate();
  const onChange = (key) => {};
  const location = useLocation();
  const detailsData = location;
  console.log("🚀 ~ CourseDetails ~ detailsData:", detailsData);
  const conditionalData = id?.includes("Course")
    ? courseModuleData
    : courseDataDetails;

  useEffect(() => {
    if (id?.includes("Course")) {
      dispatch(getCourseModulesDetailsData(moduleId))
        .unwrap()
        .then((res) => {});
    } else {
      dispatch(getCourseraContentsDetails(dataId))
        .unwrap()
        .then((res) => {});
    }
  }, [moduleId, dataId]);

  const courseContent = [
    {
      key: "1",
      label: (
        <p
          className="font-bold text-base"
          onClick={() => setSelectedMenu("Course Material")}
        >
          Course Material
        </p>
      ),
      children: (
        <div className="flex flex-col gap-2">
          {conditionalData?.map((week, i) => (
            <p
              key={i}
              onClick={() => {
                setSelectedWeek(week.id);
                setSelectedMenu("Course Material");
              }}
              className={`cursor-pointer text-sm ${
                selectedWeek === week.id ? "font-bold" : ""
              }`}
            >
              {week
                ? id?.includes("Course")
                  ? `Week ${i + 1}`
                  : `Course ${i + 1}`
                : "asdsad"}
            </p>
          ))}
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <p
          className="font-bold text-base"
          onClick={() => setSelectedMenu("Instructors")}
        >
          Instructors
        </p>
      ),
      // children: <p>{text}</p>,
    },
    // {
    //   key: "3",
    //   label: (
    //     <p
    //       className="font-bold text-base"
    //       onClick={() => setSelectedMenu("Announcements")}
    //     >
    //       Announcements
    //     </p>
    //   ),
    //   // children: <p>{text}</p>,
    // },
    // {
    //   key: "4",
    //   label: (
    //     <p
    //       className="font-bold text-base"
    //       onClick={() => setSelectedMenu("Notes")}
    //     >
    //       Notes
    //     </p>
    //   ),
    //   // children: <p>{text}</p>,
    // },
    // {
    //   key: "5",
    //   label: (
    //     <p
    //       className="font-bold text-base"
    //       onClick={() => setSelectedMenu("Program")}
    //     >
    //       Program
    //     </p>
    //   ),
    //   // children: <p>{text}</p>,
    // },
    // {
    //   key: "6",
    //   label: (
    //     <p
    //       className="font-bold text-base no-break"
    //       onClick={() => setSelectedMenu("ReadCourseForum")}
    //     >
    //       Read Course Forum
    //     </p>
    //   ),
    //   // children: <p>{text}</p>,
    // },
    // {
    //   key: "7",
    //   label: (
    //     <p
    //       className="font-bold text-base no-break"
    //       onClick={() => setSelectedMenu("Feedback")}
    //     >
    //       Feedback
    //     </p>
    //   ),
    //   // children: <p>{text}</p>,
    // },
    // {
    //   key: "8",
    //   label: (
    //     <p
    //       className="font-bold text-base no-break"
    //       onClick={() => setSelectedMenu("Grades")}
    //     >
    //       Grades
    //     </p>
    //   ),
    //   // children: <p>{text}</p>,
    // },
  ];
  const items = {
    "Course Material": (
      <CourseMaterial
        selectedCourseData={selectedCourseData}
        courseModuleSelectedData={courseModuleSelectedData}
      />
    ),
    Grades: <GradesTable />,
    Instructors: <Instructors data={data} />,
    Announcements: <Announcements />,
    Notes: <Notes />,
    Program: <Program />,
    ReadCourseForum: <ReadCourseForum />,
    Feedback: <Feedback />,
  };

  return (
    <div className="bg-pureWhite rounded-2xl p-4 courses_Style ">
      <div
        className="w-fit  flex items-center gap-x-2 cursor-pointer"
        onClick={() => navigate(-1)}
      >
        <LeftOutlined style={{ color: "#8F8F8F", fontSize: 18 }} />
        <p className="text-[#8F8F8F] text-sm">Back to courses</p>
      </div>
      <div className="mt-7 flex justify-between items-center">
        <div className="flex gap-x-4">
          <div className="">
            <img
              src={data?.extraMetadata.definition.promoPhoto}
              alt="Course Main Image"
              className="w-[135px] h-[135px]"
            />
          </div>
          <div className="flex flex-col">
            <p className="">{data?.partners[0].name}</p>
            <p className="text-[36px] font-semibold font-bizmo">{data?.name}</p>
          </div>
        </div>
        <div className="flex flex-col justify-center">
          <GradientButton>
            <Link target="_" to={contentUrl}>
              Enroll Course
            </Link>
          </GradientButton>
          {/* <p className="text-right text-[10px] text-[#8F8F8F] mt-5">
            Start date: September 13, 2023 PDT
          </p>
          <p className="text-right text-[10px] text-[#8F8F8F] mt-1">
            Estimated end date: October 29, 2023 PDT
          </p> */}
        </div>
      </div>
      <div className="mt-10 h-full flex gap-4">
        <div className="w-[35%] h-full">
          <MyCollapse items={courseContent} onChange={onChange} />
        </div>
        {console.log(items[selectedMenu], " =sjadasda, ", selectedMenu)}
        <div className="w-full h-full overflow-auto">
          {items[`${selectedMenu}`]}
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;
